const URLS_TO_PURGE = {
  TEAM_BUSTER: ["GET_USER_TEAM"],
};

export const TEAM_BUSTER = "TEAM_BUSTER";
export const LEAGUE_BUSTER = "LEAGUE_BUSTER";
export const HOME_BUSTER = "HOME_BUSTER";

export const FEED_BUSTER = {
  CONFIG: "si-mix-api-config-buster",
  STATISTICS: "si-mix-api-statistics-buster",
  TRANSLATION: "si-mix-api-translation-buster",
  STATIC_PAGE: "si-mix-api-static-page-buster",
  FIXTURES: "si-mix-api-fixtures-buster",
  ANNOUNCEMENT: "si-mix-api-announcement-buster",
  GENERIC_CARD: "si-mix-api-generic-card-buster",
};
